import React from "react";
import MDInput from "materialDashboard/components/MDInput";
import MenuItem from "@mui/material/MenuItem";
import {useTranslation} from "react-i18next";

const AcceptsModelSelect = ({value, onChange, modelType, ...props}) => {
    const {t} = useTranslation(["inputs"]);

    const translationKey = modelType === 'model1' ? "acceptsModel1Select" : "acceptsModel23Select";

    return (
        <MDInput select
                 value={value ?? ''}
                 onChange={onChange}
                 variant="standard"
                 fullWidth
                 SelectProps={{
                     displayEmpty: true,
                 }}
                 InputLabelProps={{
                     shrink: true,
                 }}
                 label={t(`${translationKey}.label`)}
                 {...props}>
            <MenuItem value="true">{t(`${translationKey}.accepts`)}</MenuItem>
            <MenuItem value="false">{t(`${translationKey}.doesNotAccept`)}</MenuItem>
            <MenuItem value="">{t(`${translationKey}.any`)}</MenuItem>
        </MDInput>
    );
};

export default AcceptsModelSelect;
